<template>
  <div class="page-header__toggle">
    <ul class="page-header__menu">
      <li class="page-header__menu-item d-none d-sm-block">
        <router-link :to="{name: 'delivery', params: {restaurantId: activeRestaurantId}}" class="page-header__menu-link">{{$t("Доставка")}}</router-link>
      </li>
      <HeaderToggleItem v-for="(item, index) in menu"
                        :item="item"
                        :key="index"
      >
        <HeaderToggleItem v-for="(item2, index2) in item.restaurants"
                          :item="item2"
                          :key="index2"
                          :to-child="item.toChild"
        >
          <HeaderToggleItem v-for="(item3, index3) in item2.restaurants"
                            :item="item3"
                            :key="index3"
                            :to-child="item.toChild"
                            :category-id="item2.id"
                            :category-slug="item2.slug"
          />
        </HeaderToggleItem>
      </HeaderToggleItem>
    </ul>
    <div class="page-header__toggle-footer d-none d-sm-flex">
      <a :href="`tel:${settings.phone}`" class="page-header__link">
        <i class="fa fa-phone"></i>
        <span class="page-header__link-text">{{settings.phone}}</span>
      </a>

      <LangSelect to-top/>

    </div>
  </div>
</template>

<script>
  import HeaderToggleItem from './HeaderToggleItem'
  import LangSelect from './LangSelect'
  import {mapState} from 'vuex'

  export default {
    name: 'HeaderToggle',
    components: {LangSelect, HeaderToggleItem},
    data() {
      return {
        menu: [
          {
            title: this.$t('Ресторани'),
            to: 'restaurants-list',
            toChild: 'restaurant',
            restaurants: [],
          },
          {
            title: this.$t('Меню'),
            to: 'menu-list',
            toChild: 'menu',
            restaurants: [],
          },
          {
            title: this.$t('Новини'),
            to: 'news-list'
          },
          {
            title: this.$t('Вакансії'),
            to: 'vacancies'
          },
          {
            title: this.$t('Контакти'),
            to: 'contacts'
          }
        ]
      }
    },
    computed: {
      ...mapState('restaurants', ['active_restaurant']),
      activeRestaurantId() {
        let id = window.localStorage.getItem('active_restaurant_id') || null
        if (this.active_restaurant) {
          id = this.active_restaurant.id
        }
        return id
      },
      restaurants() {
        return this.$store.state.restaurants
      },
      settings() {
        return this.$store.state.settings.settings
      }
    },
    methods: {
      loadMenuLinks() {
        this.addMenuItems(0, this.restaurants)
        this.addMenuItems(1, this.restaurants)
      },
      addMenuItems(index, data) {
        this.menu[index].restaurants = data.categories
        this.menu[index].restaurants = this.menu[index].restaurants.concat(data.restaurants)
      }
    },
    created() {
      this.loadMenuLinks()
    }
  }
</script>

<style>

</style>
